import { h, Component } from 'preact'
import AlertComponent from '../ui-components/AlertComponent'
import axios from 'axios'
import ExperimentalFeature from './ExperimentalFeature'
import Header from '../header'
import { common } from '../common'
import WarningBox from '../ui-components/WarningBox'
import globals from '../../utils/globals'

type Props = {}

type Features = {
  moderationOverviewBetaForTeam: boolean,
  richTopicCards: boolean
}

type State = {
  features: Features,
  showAlert: boolean,
  alertType: string|null,
  alertMessage: string|null,
  alertVisibleFor: number|null,
}

const titles = {
  moderationOverviewBetaForTeam: 'Moderation overview - enable for all Control users',
  richTopicCards: 'Rich topic cards'
}

class ExperimentalFeatures extends Component<{}, State> {
  constructor () {
    super()
    this.state = {
      features: {
        moderationOverviewBetaForTeam: common.isModuleActive('moderationOverviewBetaForTeam'),
        richTopicCards: common.isModuleActive('richTopicCards')
      },
      showAlert: false,
      alertType: null,
      alertMessage: null,
      alertVisibleFor: null,
    }
  }

  async onToggleFeature (feature: keyof Features) {
    const { features } = this.state
    await axios.post('/experimentalFeatures/save', { module: feature, enable: !features[feature] })
      .then(() =>     this.setState({
        features: Object.assign(features, { [feature]: !features[feature] }),
        showAlert: true,
        alertType: 'success',
        alertMessage: `‘${titles[feature]}’ is updated successfully!`,
        alertVisibleFor: 3000
      }))
      .catch(() => this.setState({
        showAlert: true,
        alertType: 'error',
        alertMessage: null
      }))
  }

  render (_: Props, { features, showAlert, alertType, alertMessage, alertVisibleFor }: State) {
    return (
      <div class='experimental-features'>
        {showAlert && <AlertComponent
            messageType={alertType}
            message={alertMessage}
            isVisibleFor={alertVisibleFor}
            sticky
            onTimeoutEnd={() => this.setState({ showAlert: false })}
        />}
        <Header title='Experimental Features' disableSaveButton disableCancelButton />
        <WarningBox message="On this page, you can opt in and out of experimental features that we're testing on the inSided platform." />

        <ExperimentalFeature
          title={titles.moderationOverviewBetaForTeam}
          description='The beta is enabled by default for community managers and administrators. Use this switch to enable it for your whole moderation team.'
          giveFeedbackLink='https://community.insided.com/article/905?t=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcnRpY2xlX2lkIjo5MDV9.ujERTn6KV2Hq2o0tdkznD6FRJZ0XHE0vzcaQQjRbTKs'
          previewImage={<img style={{width: '144px'}} src={`${globals('basePath')}images/features/moderationOverview.png`} />}
          isEnabled={features.moderationOverviewBetaForTeam}
          onToggleFeature={() => this.onToggleFeature('moderationOverviewBetaForTeam')}
        />

        <br/>

        <ExperimentalFeature
          title={titles.richTopicCards}
          description='When enabled this feature will replace topic links with rich cards showing the author and the title of the topic in the rich text editor'
          previewImage={<img style={{width: '144px'}} src={`${globals('basePath')}images/features/richTopicCards.png`} />}
          isEnabled={features.richTopicCards}
          onToggleFeature={() => this.onToggleFeature('richTopicCards')}
        />
      </div>
    )
  }
}

export default ExperimentalFeatures
